module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-400-latin-ext5.d035c4a.woff2";